import { render, staticRenderFns } from "./MapHatchBackwardDiagonal.vue?vue&type=template&id=071c8029&scoped=true&"
import script from "./MapHatchBackwardDiagonal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MapHatchBackwardDiagonal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c8029",
  null
  
)

export default component.exports